module.exports = __webpack_public_path__ + "media/v2/components/Contests/shared/Image/bitmap-3d54b085d377bef1539b4358adeb342c.png";